module.exports = __webpack_public_path__ + "static/media/1.4268fda2.png";